export const data = [
  {
    key: 0,
    name: "UBI Accelerator",
    instanceName: "ubi_accel-demo",
    rds: ['ubix-demo-rds-final', 'ubi-accel-demo-target', 'ubi-accel-demo-source'],
    lamdaUrl: "REACT_APP_LAMBDA_URL1",
    icon: "/accelerator.png",
    description:
      "Efficiently automate data pipelines for data lakes and warehouses, with seamless onboarding, UI-driven metadata configuration, and effective delta detection using key attributes.",
    btntxt: "Product images",
    link: "https://usefulbi.com/ubi-xcelerator/",
    link2: "http://dev-accelerator.usefulbi.com/",
    fontSize: "0.8rem",
    imgwidth: "100px",
    imgheight: "91px",
    tag: ["Lifesciences", "BFSI", "Automotive", "Data Engineering"],
    type: "industry",
  },
  {
    key: 1,
    name: "Site Viability Tool",
    instanceName: "csvt",
    rds: ['clinical-postgres'],
    lamdaUrl: "REACT_APP_LAMBDA_URL3",
    icon: "/Clinical.png",
    description:
      "Streamline AI model serving with our advanced solution, enabling efficient deployment, scaling, and monitoring of models for seamless integration into your company's operations.",
    btntxt: "Product images",
    link: "https://usefulbi.com/clinical-operations-study-viability/",
    link2:
      "https://csvt.usefulbi.com/",
    fontSize: "0.8rem",
    imgwidth: "100px",
    imgheight: "91px",
    tag: ["Lifesciences", "Data Engineering"],

    type: "industry",
  },
  {
    key: 2,
    name: "Conversational AI",
    instanceName: "GenAI-Studio",
    lamdaUrl: "REACT_APP_LAMBDA_URL3",
    icon: "/Chatbot_1.png",
    description:
      "Transform patient interactions with our cutting-edge conversational AI solution. Seamlessly personalize conversations to deliver exceptional user experiences and engagement.",
    link: "https://usefulbi.com/ai-automation/",
    btntxt: "Try it Out",
    link2: "https://Genai-studio.usefulbi.com/",
    fontSize: "0.9rem",
    imgwidth: "100px",
    imgheight: "83px",
    tag: ["Lifesciences", "BFSI", "Automotive", "Gen AI"],
    type: "industry",
  },
  {
    key: 3,
    name: "Site Data Management",
    instanceName: "Clinical_data_management",
    rds: ['csvt'],
    lamdaUrl: "REACT_APP_LAMBDA_URL3",
    icon: "/Clinical-Data.png",
    description:
      "Simplify and enhance your clinical data management with our comprehensive solution, streamlining data collection, organization, and analysis for efficient and compliant clinical research processes with outmost ease.",
    btntxt: "Try it Out",
    link: "https://usefulbi.com/clinical-data-management/",
    link2:
      "https://cdm.usefulbi.com/",
    fontSize: "0.9rem",
    imgwidth: "100px",
    imgheight: "91px",
    tag: ["Lifesciences", "BFSI", "Automotive", "Data Engineering"],
    type: "industry",
  },
  {
    key: 4,
    name: "IntelliSearch AI",
    instanceName: "GenAI-Studio",
    lamdaUrl: "REACT_APP_LAMBDA_URL3",
    icon: "/AWS.png",
    description:
      "Supercharge your search capabilities with IntelliSearch AI. Leverage our solution to unlock powerful and intelligent search functionalities, enabling effortless retrieval of relevant information ,informed decison making.",
    btntxt: "Try it Out",
    link: "https://usefulbi.com/ai-accelerator/",
    link2: "https://Genai-studio.usefulbi.com/",
    fontSize: "0.9rem",
    imgwidth: "90px",
    imgheight: "91px",
    tag: ["Lifesciences", "BFSI", "Automotive", "Data Science", "Gen AI"],
    type: "industry",
  },
  {
    key: 5,
    name: "UBI Pro Launch",
    instanceName: "PharmLaunch",
    lamdaUrl: "REACT_APP_LAMBDA_URL2",
    mongoDbUrl: "REACT_APP_LAMBDA_URL4",
    icon: "/Pharma.png",
    description:
      "Streamline your pharma drug launch planning with UBI Pharma Launch - the cutting-edge software solution designed to optimize efficiency, enhance collaboration, and drive successful product launches.",
    btntxt: "Try it Out",
    link2: "https://pharmlaunch.usefulbi.com/",
    link: "https://usefulbi.com/ubi-pharmlaunch/",
    fontSize: "0.9rem",
    imgwidth: "95px",
    imgheight: "91px",
    tag: ["Lifesciences", "Project Planning", "Automotive", "BFSI"],
    type: "industry",
  },
  {
    key: 6,
    name: "Oncology Trials Case Study",
    icon: process.env.PUBLIC_URL + "/Oncology.png",
    description:
      "Discover the future of cancer research with our Tableau solution! Visualize oncology trial data, uncover hidden patterns, and make informed decisions quickly with our intuitive, interactive dashboards.",
    link: "https://usefulbi.com/data-and-analytics/",
    btntxt: "Try it Out",
    link2: process.env.PUBLIC_URL + "/UBI demo on oncology trials.html",
    fontSize: "0.9rem",
    imgwidth: "100px",
    imgheight: "100px",
    tag: ["Lifesciences", "Business Intelligence", "Tableau"],
    type: "industry",
  },
  {
    key: 7,
    name: "Open Payments Case Study",
    icon: process.env.PUBLIC_URL + "/Money.png",
    description:
      "Transform your financial analysis with our advanced Tableau dashboards. Easily visualize Open Payments data, uncover insights into financial relationships and compliance trends, and drive strategic decisions with clear, actionable visuals.",
    link: "https://usefulbi.com/data-and-analytics/",
    btntxt: "Try it Out",
    link2: process.env.PUBLIC_URL + "/UBI demo on open payments.html",
    fontSize: "0.9rem",
    imgwidth: "100px",
    imgheight: "100px",
    tag: ["BFSI", "Tableau", "Business Intelligence"],
    type: "industry",
  },
  {
    key: 8,
    name: "Lot Genealogy Case Study",
    icon: process.env.PUBLIC_URL + "/Genology.png",
    description:
      "Explore product lot connections with our Tableau visualization tools. Seamlessly trace and analyze lot genealogy, identify critical patterns, and enhance quality control with dynamic, user-friendly dashboards.",
    link: "https://usefulbi.com/data-and-analytics/",
    btntxt: "Try it Out",
    link2: process.env.PUBLIC_URL + "/UBI demo on lot geneology.html",
    fontSize: "0.9rem",
    imgwidth: "100px",
    imgheight: "100px",
    tag: ["Lifesciences", "Business Intelligence", "Tableau"],
    type: "industry",
  },
  {
    key: 9,
    name: "Demo on FDA Adverse Events",
    icon: process.env.PUBLIC_URL + "/FDA.png",
    description:
      "Experience the power of Tableau in monitoring FDA adverse events with our demo. Effortlessly visualize and interact with data, identify trends and correlations, and streamline reporting with clear, actionable insights.",
    link: "https://usefulbi.com/data-and-analytics/",
    btntxt: "Try it Out",
    link2: process.env.PUBLIC_URL + "/UBI demo on FDA adverse events.html",
    fontSize: "0.9rem",
    imgwidth: "100px",
    imgheight: "100px",
    tag: ["Lifesciences", "Business Intelligence", "Tableau"],
    type: "industry",
  },
  {
    name: "CMC RA",
    icon: "/reporting.png",
    description:
      "CMC Regulatory Affairs is an AI-powered platform that automates CMC regulatory documentation workflows.",
    link: "https://usefulbicorp.sharepoint.com/:p:/r/sites/MVPInnovationHub/_layouts/15/Doc.aspx?sourcedoc=%7B691C3EC1-624A-4A71-9401-331360929EE9%7D&file=CMC-RA.pptx&action=edit&mobileredirect=true",
    btntxt: "Try it Out",
    link2: "https://cmc-ra.usefulbi.com/",
    fontSize: "0.9rem",
    imgwidth: "100px",
    imgheight: "100px",
    tag: ["Gen AI", "Regulatory Affairs", "Document Automation", "Lifesciences", "CMC"],
    type: "usecase",
  },
  {
    name: "HA-RTQ",
    icon: process.env.PUBLIC_URL + "/Chatbot_1.png",
    description:
      "HA-RTQ is an AI-powered assistant that helps regulatory teams quickly and accurately respond to Health Authority queries.",
    link: "https://usefulbicorp.sharepoint.com/:p:/r/sites/MVPInnovationHub/_layouts/15/Doc.aspx?sourcedoc=%7BF9331247-0557-444E-8801-80074A5E863D%7D&file=HA-RTQ.pptx&action=edit&mobileredirect=true",
    btntxt: "Try it Out",
    link2: "https://ha-rtq.usefulbi.com/",
    fontSize: "0.9rem",
    imgwidth: "100px",
    imgheight: "100px",
    tag: ["Gen AI", "Regulatory Affairs", "Lifesciences", "Health Authority"],
    type: "usecase",
  },
  {
    name: "UBI Content Generator",
    icon: process.env.PUBLIC_URL + "/AWS.png",
    description:
          "A unified AI platform for generating regulatory-ready Clinical Study Reports with built-in quality checks, traceability, and human review.",
      link: "https://usefulbicorp.sharepoint.com/:p:/r/sites/MVPInnovationHub/_layouts/15/Doc.aspx?sourcedoc=%7B856D8D23-7326-4619-801F-4D37066A957A%7D&file=UBI-Reg-Gen%20(CSR).pptx&action=edit&mobileredirect=true&xsdata=MDV8MDJ8fGZmOTQ3YmUzZmM3NzRiODExZTRiMDhkZTRkYjBmYTFhfDUyZmRjY2ZkOTc1MTQ1MWFiMzRmOWQzYmU4ZjQxYmU3fDB8MHw2MzkwMzM2MTk2Mzg3ODc2NTl8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T2pFME9EUmlNV1ppTFdaaFptUXROR1F6TUMwNE16TmhMVEExWm1VMVlUZGlNVFF3TkY4MFl6UXpObVEzTXkwNE5Ua3dMVFF5TUdZdE9XSmpaQzB3TW1KbE1USTNaRFEwT0dGQWRXNXhMbWRpYkM1emNHRmpaWE12YldWemMyRm5aWE12TVRjMk56YzJOVEE1TkRFNU5BPT18OTBiMjk1MzFkZTg2NDY0Njk4YjIwOGRlNGRiMGZhMTl8ZmM1MjIwZmE2ZGU4NDA2YmE4ZDZmNWI5YzFlOWM3MDc%3D&sdata=SjhTS2t0dTE5TTc0MGVoQjFoOXBmb0NnSFBzQStodGFTU0hNby95N0RXZz0%3D&ovuser=52fdccfd-9751-451a-b34f-9d3be8f41be7%2CRishabh%40usefulbi.com",
      btntxt: "Try it Out",
      link2: "https://reg-gen.usefulbi.com/",
      fontSize: "0.9rem",
      imgwidth: "100px",
      imgheight: "100px",
      tag: ["Gen AI", "Regulatory Writing", "Lifesciences", "Automation"],
      type: "usecase",
      }
];
